import React, { useState } from "react";
import { object, string } from "prop-types";
import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useSelector } from "react-redux";
import checkAuth from "../../../utils/checkAuth";
import EditCampaignModal from "./EditCampaignModal";

export default function EditCampaignButton({ campaign, text }) {
  const [visible, setVisible] = useState(false);

  const roles = useSelector(state => state.auth.roles);

  if (!campaign || !checkAuth.has(roles, ["admin"])) return null;

  return (
    <span>
      <Button
        type="primary"
        key="close"
        icon={<EditOutlined />}
        onClick={() => setVisible(true)}
      >
        {text}
      </Button>

      <EditCampaignModal
        campaign={campaign}
        visible={visible}
        onClose={() => setVisible(false)}
      />
    </span>
  );
}

EditCampaignButton.propTypes = {
  campaign: object,
  text: string,
};
